<template>
  <div :class="'md-layout'">
    <div :class="'md-layout-item md-size-66 md-xsmall-size-80 mx-auto'">
      <simple-wizard>
        <template slot="header">
          <h3 :class="''"></h3>
        </template>
        <wizard-tab :before-change="() => validateStep('firstStep')">
          <template slot="label"> Administrative Information </template>
          <first-step
            :users="users"
            :clusters="clusters"
            :arrs="arrs"
            :disabled="isSavingARQ"
            :isSaving="isSavingARQ"
            :canEdit="true"
            ref="firstStep"
            @validate="onStepValidated"
          ></first-step>
        </wizard-tab>
        <wizard-tab :before-change="() => validateStep('secondStep')">
          <template slot="label"> Engagement Information </template>
          <second-step
            :disabled="isSavingARQ"
            :canEdit="true"
            ref="secondStep"
            @validate="onStepValidated"
          ></second-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>

<script>
import { SimpleWizard, WizardTab } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import FirstStep from "./Create/FirstStep.vue";
import SecondStep from "./Create/SecondStep.vue";
import { camelToSnake } from "@/methods/api/requests"

export default {
  components: {
    SlideYDownTransition,
    SimpleWizard,
    WizardTab,
    FirstStep,
    SecondStep,
  },

  data() {
    return {
      wizard: {},

      users: [],
      clusters: [],
      arrs: [],

      isSavingARQ: false,

      errorResponses: {
        422: "There is an error with the RQR",
      },
    };
  },

  methods: {
    validateStep(ref) {
      if (this.isSavingARQ) {
        return false;
      }

      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model, finishedForm) {
      if (!validated) {
        return;
      }

      this.wizard = { ...this.wizard, ...model };

      if (finishedForm) {
        this.isSavingARQ = true;

        this.$api.request
          .post("reviews", this.wizard)
          .then(() => {
            this.$toast.show("RQR successfully created", "");
            this.$router.push({ name: "Reviews" });
          })
          .catch((error) => {
            if (this.errorResponses[error.response.status]) {
              this.$toast.show(this.errorResponses[error.response.status]);
            } else {
              this.$toast.show("Ops, something went wrong! Please, try again.");
            }
          })
          .finally(() => {
            this.isSavingARQ = false;
          });
      }
    },


    getUsers() {
      this.$api.request("all/users").then((response) => {
        this.users = camelToSnake(response.data)
          .filter(d => d.inactive_user === null)
          // .sort((a, b) => a.name.localeCompare(b.name));
      });
    },

    getClusters() {
      this.$api.request("all/clusters").then((response) => {
        this.clusters = camelToSnake(response.data)
          // .sort((a, b) => a.name.localeCompare(b.name));
      });
    },

    getAdvisories() {
      this.$api.request("all/advisories").then((response) => {
        this.arrs = camelToSnake(response.data)
          // .sort((a, b) => a.reference.localeCompare(b.reference));
      });
    },
  },

  created() {
    this.getUsers();
    this.getClusters();
    this.getAdvisories();
  },

};
</script>
